import { formatCurrency } from './format-currency'
import { truncateFloat } from './truncate-float'

const formatter = new Intl.NumberFormat('pt-BR', { style: 'percent', minimumFractionDigits: 2, maximumFractionDigits: 2 })

export const getValorPercentMessages = (total, automatica, manual) => {
  const restante = total - automatica - manual

  const percentAutomatica = () => {
    const diferenca = automatica - total
    if (diferenca > -0.001) {
      return 1
    }

    return truncateFloat(automatica / total, 4)
  }
  const percentManual = () => {
    const diferenca = manual - total
    if (diferenca > -0.001) {
      return 1
    }

    return truncateFloat(manual / total, 4)
  }
  const percentRestante = truncateFloat(restante / total, 4)

  const formattedCurrencyTotal = formatCurrency(total)
  const formattedCurrencyAutomatica = formatCurrency(automatica)
  const formattedCurrencyManual = formatCurrency(manual)
  const formattedCurrencyRestante = formatCurrency(restante)

  const formattedPercentAutomatica = total ? formatter.format(percentAutomatica()) : '-%'
  const formattedPercentManual = total ? formatter.format(percentManual()) : '-%'
  const formattedPercentRestante = total ? formatter.format(percentRestante) : '-%'

  return {
    textAutomatica: `${formattedCurrencyAutomatica} de ${formattedCurrencyTotal} conciliados automaticamente (${formattedPercentAutomatica})`,
    textManual:`${formattedCurrencyManual} de ${formattedCurrencyTotal} conciliados manualmente (${formattedPercentManual})`,
    textRestante: `${formattedCurrencyRestante} de ${formattedCurrencyTotal} não conciliados (${formattedPercentRestante})`,
  }
}
